import { render, staticRenderFns } from "./CardCredentials.vue?vue&type=template&id=289a4886&scoped=true&"
import script from "./CardCredentials.vue?vue&type=script&lang=js&"
export * from "./CardCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a4886",
  null
  
)

export default component.exports